<div class="flex items-center gap-3 text-sm">
  <span>{{ 'pages.campaignDetails.deliverables.groupByContent' | translate }}</span>
  <mat-slide-toggle [checked]="checked()" [hideIcon]="true" (change)="onCheckedChange($event)" />
</div>
